<template>
    <b-container class="mx-3 my-5">
        <b-row>
            <b-col>
                <div>
                    <p class="h4">
                        <strong>Browse Nearby</strong>
                    </p>
                    <p>
                        <b-link href="#foo">Restaurants</b-link>
                    </p>
                    <p>
                        <b-link href="#foo">Nightlife</b-link>
                    </p>
                    <p>
                        <b-link href="#foo">Shopping</b-link>    
                    </p>
                    <p>
                        <b-link href="#foo">Show all</b-link>
                    </p>
                </div>
            </b-col>
            <b-col>
                 <div>
                    <p class="h4">
                        <strong>Near Me</strong>
                    </p>
                    <p>
                        <b-link href="#foo">Bakeries Near Me</b-link>

                    </p>
                    <p>
                        <b-link href="#foo">Cheesecake Factory Near Me</b-link>
                    </p>
                    <p>
                        <b-link href="#foo">Desserts Near Me</b-link>
                    </p>
                    <p>
                        <b-link href="#foo">Wedding Cake Bakeries Near Me</b-link>
                    </p>
                </div>
            </b-col>
            <b-col>
                 <div>
                    <p class="h4">
                        <strong>Other Places Nearby</strong>
                    </p>
                    <p>
                        <b-link href="#foo">Find more Bakeries near Becky's Kitchen</b-link>
                    </p>
                    <p>
                        <b-link href="#foo">Find more Desserts near Becky's Kitchen</b-link>
                    </p>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
export default {
    
}
</script>